// frontend/super-admin/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';

// तुझा मूळ इम्पोर्ट्स
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Tenants from './pages/Tenants';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import Plans from './pages/Plans'; // ✅ ADDED
import PaymentRequests from './pages/PaymentRequests'; // ✅ NEW
import PaymentSettings from './pages/PaymentSettings'; // ✅ NEW

// नवीन इम्पोर्ट्स
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#25D366',
        },
      }}
    >
      {/* नवीन ॲड केलेला भाग जो तुझं मूळ लॉजिक खराब करणार नाही */}
      <div className="App" style={{ display: 'none' }}> 
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
        </header>
      </div>

      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="tenants" element={<Tenants />} />
            <Route path="plans" element={<Plans />} /> {/* ✅ ADDED */}
            <Route path="payment-requests" element={<PaymentRequests />} /> {/* ✅ NEW */}
            <Route path="payment-settings" element={<PaymentSettings />} /> {/* ✅ NEW */}
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;